export class Session {
  constructor(
    public accountId: number,
    public userId: number,
    public body: string
  ) {}
}
